import { IQuote } from './interfaces';
import Gallery from '../../../galleries/gallery/gallery';
import { isMobile } from '../../../../domain/common';
import React from 'react';
import Imgix from 'react-imgix';

interface IOnlineMasteringQuotesGalleryProps {
    quotes: IQuote[];
}

const OnlineMasteringQuotesGallery = ({
    quotes
}: IOnlineMasteringQuotesGalleryProps) => {

    const imageCDNDomain = (document.getElementById('img-cdn-domain')?.textContent || '')?.trim().toLowerCase();

    return (
        <div className="olm-quotes-gallery text-white">

            <div>
                <Gallery
                    adaHideNonVisibleSlides={ true }
                    galleryStaticContentClasses=""
                    galleryStaticContentArrowClasses="mb-0"
                    allowVerticalScrolling={ true }

                    desktopItemsPerSlide={ 3 }
                    tableItemsPerSlide={ 3 }
                    mobileItemsPerSlide={ 1.5 }
                    codeName="olm_quotes"
                    items={ quotes }
                    loop={ true }
                    classes="w-full"
                    gap={ isMobile() ? 4 : 2 }
                    duration={ 1500 }
                    arrowsColor="white"
                    renderItem={(item: IQuote) => {

                        return (
                            <div
                                key={ `index-${ item.quote }` }
                                className="flex flex-col items-center gap-4">


                                <Imgix
                                    src={ `${ imageCDNDomain }${ item.image ?? '' }` }
                                    width={ 115 }
                                    height={ 115 }
                                    htmlAttributes={{
                                        alt: `Image for ${  item.image }`,
                                        // loading: 'lazy',
                                    }}
                                />

                                <div style={{
                                    width: '215px'
                                }}>{ item.quote }</div>

                                <div className="font-bold text-lg mt-2">{ item.artist_name }</div>
                                <div className="text-sm olm-comment-opacity olm-credits-gallery-item">{ item.credits }</div>
                            </div>
                        )
                    } }
                />
            </div>
        </div>
    )
};

export default OnlineMasteringQuotesGallery;